<script>
import {
  listeDeCoursesOverviewProps,
  useListeDeCoursesOverview
} from "./mixin";
import Card from "@/components/molecules/card";
import Button from "@/components/atoms/button";
import ButtonIcon from "@/components/molecules/button-icon";
import Divider from "@/components/atoms/divider";
import LinkTo from "@/components/atoms/link-to";

export default {
  name: "ListeDeCoursesOverview",
  components: { Card, Divider, Button, ButtonIcon, LinkTo },
  props: {
    ...listeDeCoursesOverviewProps()
  },
  emits: ["delete", "addToCart"],
  setup(props) {
    const { countProduits, dateLastUsageFormatted } =
      useListeDeCoursesOverview(props);
    return { countProduits, dateLastUsageFormatted };
  }
};
</script>

<template>
  <Card
    class="c-liste-de-course-overview u-pl-md u-pt-md u-pr-md u-pb-sm u-flex-item-fluid"
    radius="lg"
    elevation="sm"
  >
    <div class="u-text-right">
      <ButtonIcon
        icon-name="cross"
        icon-size="xs"
        icon-color="text-light"
        radius="full"
        variant="grey-6"
        size="xs"
        class="c-liste-de-course-overview__delete"
        @click="$emit('delete', liste)"
      />
    </div>
    <div class="u-flex u-flex-justify-between u-flex-align-center u-flex-wrap@lg u-mb-sm">
      <LinkTo
        :to="`/mon-compte/mes-listes-de-courses/${liste.id}`"
        no-underline
        variant="text"
        class="c-liste-de-course-overview__title u-font-15 u-mb-sm@lg"
      >
        <strong class="u-font-500">
          {{ liste.attributes.titre }}
        </strong>
      </LinkTo>
      <Divider
        vertical
        dotted
        size="sm"
        class="u-m-none u-none@lg"
      />
      <p class="c-liste-de-course-overview__date u-font-15 u-text-left">
        {{ dateLastUsageFormatted }}
      </p>
      <Divider
        vertical
        dotted
        size="sm"
        class="u-m-none"
      />
      <p class="c-liste-de-course-overview__items u-font-15 u-text-left">
        {{ countProduits }} {{ pluralize(countProduits, 'produit') }}
        <template v-if="liste.attributes.nb_produits_manquant > 0">
          (dont {{ liste.attributes.nb_produits_manquant }} {{ pluralize(liste.attributes.nb_produits_manquant, 'indisponible') }})
        </template>
      </p>
    </div>
    <Divider size="sm" />
    <div class="u-flex u-flex-align-center u-flex-justify-end u-mt-xs">
      <!-- <div class="u-pr-lg">
        <Button link>
          Ajouter à mes listes favorites
        </Button>
      </div> -->
      <div class="u-pr-lg">
        <Button
          link
          :to="`/mon-compte/mes-listes-de-courses/${liste.id}`"
        >
          Voir la liste
        </Button>
      </div>
      <ButtonIcon
        link
        icon-name="cart-circle"
        icon-size="sm"
        icon-color="secondary"
        :disabled="liste.attributes.nb_produits === 0"
        @click="$emit('addToCart', liste)"
      >
        Ajouter la liste au panier
      </ButtonIcon>
    </div>
  </Card>
</template>

<style lang="scss" scoped>
.c-liste-de-course-overview {
  position: relative;
}
.c-liste-de-course-overview__delete {
  position: absolute;
  top: spacing(xs);
  right: spacing(xs);
}

.c-liste-de-course-overview__title,
.c-liste-de-course-overview__date,
.c-liste-de-course-overview__items {
  padding: 0 spacing(md);
  @include mq(bp(lg)) {
    padding: 0;
  }
}
.c-liste-de-course-overview__title {
  width: 40%;
  @include mq(bp(lg)) {
    width: 100%;
    padding: 0;
  }
}
.c-liste-de-course-overview__date {
  width: 28%;
  text-align: center;
  @include mq(bp(lg)) {
    width: 48%;
    text-align: left;
    padding-right: spacing(sm);
  }
}
.c-liste-de-course-overview__items {
  width: 38%;
  @include mq(bp(lg)) {
    width: 48%;
    padding-left: spacing(sm);
  }
}
</style>
